"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInsertTextTool = exports.createInsertTool = void 0;
/* eslint-disable react/display-name */
const React = __importStar(require("react"));
const kendo_react_buttons_1 = require("@progress/kendo-react-buttons");
const kendo_react_editor_1 = require("@progress/kendo-react-editor");
// function eventPhaseText(e: Event) {
//    switch (e.eventPhase) {
//       case e.NONE:
//          return "NONE";
//       case e.BUBBLING_PHASE:
//          return "BUBBLING";
//       case e.CAPTURING_PHASE:
//          return "CAPTURING";
//       case e.AT_TARGET:
//          return "TARGET";
//       default:
//    }
//    return "unknown phase";
// }
exports.createInsertTool = (settings) => (props) => {
    const { view } = props;
    const { items } = settings;
    const nodeSpec = view && view.state.schema.nodes[settings.nodeType || "text"];
    const canInsert = view && kendo_react_editor_1.EditorUtils.canInsert(view.state, nodeSpec);
    return (React.createElement(kendo_react_buttons_1.DropDownButton, Object.assign({ text: settings.title, items: items, textField: "text", itemRender: ({ item }) => {
            const theDiv = React.useRef(null);
            const clickHandler = React.useCallback(_event => {
                const textToInsert = settings.getTextToInsert
                    ? settings.getTextToInsert(item)
                    : item.text;
                kendo_react_editor_1.EditorUtils.insertNode(view, kendo_react_editor_1.ProseMirror.Node.fromJSON(view.state.schema, {
                    type: settings.nodeType || "text",
                    text: textToInsert,
                    attrs: settings.attrs
                        ? settings.attrs(textToInsert)
                        : undefined
                }), true);
            }, [item]);
            const parentMouseDown = React.useCallback(e => {
                e.preventDefault();
                // console.log(
                //    "parent mousedown",
                //    eventPhaseText(e),
                //    e.defaultPrevented ? "prevented" : ""
                // );
            }, []);
            const parentClick = React.useCallback(e => {
                clickHandler(e);
                e.stopPropagation();
                view.focus();
                // console.log(
                //    "parent click",
                //    eventPhaseText(e),
                //    e.defaultPrevented ? "prevented" : ""
                // );
            }, [clickHandler]);
            React.useEffect(() => {
                const theParent = theDiv.current && theDiv.current.parentElement;
                if (theParent) {
                    // console.log(theParent);
                    theParent.addEventListener("mousedown", parentMouseDown);
                    theParent.addEventListener("click", parentClick);
                }
                return () => {
                    if (theParent) {
                        theParent.removeEventListener("mousedown", parentMouseDown);
                        theParent.removeEventListener("click", parentClick);
                    }
                };
            }, [clickHandler, parentClick, parentMouseDown]);
            return (React.createElement("div", { key: item.code, ref: theDiv, onMouseDown: e => e.preventDefault() }, item.text));
        }, disabled: !canInsert, onPointerDown: (e) => e.preventDefault() }, settings.props)));
};
exports.createInsertTextTool = (settings) => exports.createInsertTool({
    ...settings,
    nodeType: "text"
});
//# sourceMappingURL=insertTools.js.map